var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-filter d-flex gap-8 pointer"},_vm._l((_vm.filters),function(item){return _c('span',{key:item.key,class:{ active: _vm.value == item.key },on:{"click":function($event){return _vm.$emit("input", item.key)}}},[_vm._v(_vm._s(item.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }